import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { EparcoursPath } from "../../constantes/menu/menu-items/eparcours-path";
import { NavService } from "./nav-service";
import { PARAM_TOKEN } from "./navigators/navigators";

@Injectable({
  providedIn: 'root'
})
export class EvaluationsNavService  extends NavService {

  constructor(protected router: Router) {
    super(router);
  }


  liste = this.makeNavigator(
    EparcoursPath.root.EVALUATIONS
  )
  creation_achaud = this.makeNavigator(
    EparcoursPath.root.EVALUATIONS,
    EparcoursPath.evaluations.ROOT,
    EparcoursPath.evaluations.CREATION_ACHAUD,
  );

  creation_afroid = this.makeNavigator(
    EparcoursPath.root.EVALUATIONS,
    EparcoursPath.evaluations.ROOT,
    EparcoursPath.evaluations.CREATION_AFROID,
  );

  creation_preformation = this.makeNavigator(
    EparcoursPath.root.EVALUATIONS,
    EparcoursPath.evaluations.ROOT,
    EparcoursPath.evaluations.CREATION_PREFORMATION,
  );

  edition = this.makeNavigatorWithParam<number>(
    EparcoursPath.root.EVALUATIONS,
    EparcoursPath.evaluations.ROOT,
    EparcoursPath.evaluations.EDITION,
    PARAM_TOKEN
  )

}
